// import { NativeDateAdapter } from "@angular/material";


export class AppDateAdapter {

    format(date: Date, displayFormat: Object): string {

        let monthEnum = { 0: "1", 1: "2", 2: "3", 3: "4", 4: "5", 5: "6", 6: "7", 7: "8", 8: "9", 9: "10", 10: "11", 11: "12" };
        if (displayFormat === 'input') {
            const day = date.getDate();
            const month = date.getMonth();
            const year = date.getFullYear();
            return `${day}/${monthEnum[month]}/${year}`;
        } else {
            return date.toDateString();
        }
    }
}

export const APP_DATE_FORMATS =
    {
        parse: {
            dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
        },
        display: {
            dateInput: 'input',
            monthYearLabel: { year: 'numeric', month: 'numeric' },
            dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
            monthYearA11yLabel: { year: 'numeric', month: 'long' },
        }
    };